export const getDocumentMainLandmarkOrBody = () => {
  const main = document.querySelector('main');
  if (!main) {
    // eslint-disable-next-line no-console
    console.log(
      'No "main" element found in the document. Using body instead.' +
        '\nNot having a main element is usually the start of accessibility issues related to landmarks.' +
        '\nIf this is actually intentional, you should provide the correct DOM element to host the portal via portalDOMContainer',
    );
  }
  return main || document.body;
};
